import { denormalizedEntitySelector, createEntitySelector } from 'entities/selectors'
import { pendingSelector } from 'api/selectors'
import { resultsSelector } from 'dashboard-transactions/selectors'

import { locationSchema, reservationSchema } from './schemas'

export const locationsSelector = denormalizedEntitySelector(locationSchema)

export const locationSelector = grsId => createSelector(locationsSelector, locations => locations[grsId])

export const locationByPropsSelector = createSelector(
    locationsSelector,
    (_, props) => props.grsId,
    (locations, grsId) => locations[grsId]
)

export const detailsPendingSelector = createSelector(pendingSelector, pending => pending.locationDetails)
export const setAutoRenewPendingSelector = createSelector(pendingSelector, pending => pending.setAutoRenew)

export const reservationsSelector = createEntitySelector(reservationSchema)

export const reservationSelector = reservationId =>
    createSelector(reservationsSelector, reservations => reservations[reservationId])

export const lastReservationSelector = createSelector(
    reservationsSelector,
    resultsSelector,
    (reservations, reservationId) => reservations[reservationId]
)

export const reservationCancelAmendPolicyPendingSelector = createSelector(
    pendingSelector,
    pending => pending.reservationCancelAmendPolicy
)

export const cancelReservationPendingSelector = createSelector(pendingSelector, pending => pending.cancelReservation)

export const addToWaitingListPendingSelector = createSelector(pendingSelector, pending => pending.addToWaitingList)
